import { render, staticRenderFns } from "./sub-customer-editor.vue?vue&type=template&id=0326c3d0&scoped=true&"
import script from "./sub-customer-editor.vue?vue&type=script&lang=js&"
export * from "./sub-customer-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326c3d0",
  null
  
)

export default component.exports